module.exports = __webpack_public_path__ + "img/img0.ae33f03f.jpg";